'use client';

import useBannerViewModel from '@module/helpers/banner/useBannerViewModel';
function BannerContainer() {
  useBannerViewModel();
  return null;
}
export default BannerContainer;